import { render, staticRenderFns } from "./IndexProductBody.vue?vue&type=template&id=50aae06b&scoped=true"
import script from "./IndexProductBody.vue?vue&type=script&lang=js"
export * from "./IndexProductBody.vue?vue&type=script&lang=js"
import style0 from "./IndexProductBody.vue?vue&type=style&index=0&id=50aae06b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50aae06b",
  null
  
)

export default component.exports